import React from "react";
import styles from "./FHIRPatient.module.scss";
import PatientName from "./PatientName";
import Address from "./Address";
import Telecom from "./Telecom";
import Identifier from "./Identifier";
import Gender from "./Gender";
import BirthDate from "./BirthDate";

const AdditionalInformation = ({ data }) => {
  const additionalDetails = demographics =>
    demographics &&
    demographics.filter(
      item =>
        item.extension &&
        item.extension.every(
          ext =>
            ext.url === "additionalDataFromRecords" && ext.valueBoolean === true
        )
    );

  const name = (
    <PatientName
      className={styles.name}
      data={additionalDetails(data.name)}
      isAggregateInfo={true}
    />
  );

  const address = (
    <Address
      className={styles.address}
      data={additionalDetails(data.address)}
      isAggregateInfo={true}
    />
  );

  const telecom = (
    <Telecom
      className={styles.telecom}
      data={additionalDetails(data.telecom)}
      isAggregateInfo={true}
    />
  );

  const identifiers = (
    <Identifier
      className={styles.name}
      data={additionalDetails(data.identifier)}
      isAggregateInfo={true}
      isAdditionalInformation={true}
    />
  );

  const gender = (
    <Gender
      data={
        data.extension &&
        data.extension
          .filter(ext => ext.url === "additionalGendersFromRecords")
          .map(ext => ext.valueString)[0]
      }
      isAggregateInfo={true}
    />
  );
  const dob = (
    <BirthDate
      data={
        data.extension &&
        data.extension
          .filter(ext => ext.url === "additionalDoBsFromRecords")
          .map(ext => ext.valueString)[0]
      }
      isAggregateInfo={true}
    />
  );

  return (
    <div>
      <div>
        <div className={styles.heading}>Name</div>
        <div className={styles.info}>{name}</div>
      </div>
      <div>
        <div className={styles.heading}>Address</div>
        <div className={styles.info}>{address}</div>
      </div>
      <div>
        <div className={styles.heading}>Basic Demographics</div>
        <div className={styles.info}>{gender}</div>
        <div className={styles.info}>{dob}</div>
      </div>
      <div>
        <div className={styles.heading}>Telecom</div>
        <div className={styles.info}>{telecom}</div>
      </div>
      <div>
        <div className={styles.heading}>Identifier</div>
        <div className={styles.info}>{identifiers}</div>
      </div>
    </div>
  );
};

export default AdditionalInformation;
